<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="error" class="mr-3">
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h2>
              Confirma que deseja deletar a
              {{ isAT ? "iniciativa" : "solução" }}?
            </h2>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="beforeDelete">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { citySolutionAPI } from "@/modules/city/API/CitySolutionAPI";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalDeleteSolution",
  props: {
    payload: { type: Object, required: true },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters(["user", "isAT"]),
  },
  mounted() {},
  methods: {
    ...mapActions(["setLoading"]),
    onConfirm() {
      citySolutionAPI
        .delete(this.payload.municipioSolucaoId)
        .then((resp) => {
          this.dialog = false;
          this.$emit("onSave");
          this.setLoading(false);
        })
        .catch((e) => this.setLoading(false));
    },
    beforeDelete() {
      this.setLoading(true);

      citySolutionAPI
        .solutionStarted(this.payload)
        .then((resp) => {
          if (resp.data === false) {
            this.onConfirm();
          } else {
            this.$notification.error(
              `${this.isAT ? "Iniciativa" : "Solução"} já iniciada`
            );
          }
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao deletar ${this.isAT ? "Iniciativa" : "Solução"}`
          );
        });
    },
  },
};
</script>
